export default __webpack_public_path__ + "static/media/announcement-white.52e258aa.svg";